import axios from 'axios';
import './pacote/atendimento.css';
import './pacote/atendimento.js';
import './suporte.css';

// ATENDIMENTO DO CHAT (20/10/2026): o mesmo da Central web do financeiro, vindo do projeto atendimento-geogrid como
// pacote pronto (pacote/atendimento.js, com o React 19 dentro; gerado la' por "npm run publicar-suporte", nao
// editar aqui). Aqui fica so' o que e' do Suporte: o token do chat, a empresa e a dica da IA pelo PHP do Suporte
// (AtendimentoController)
const pacote = window.AtendimentoGeoGrid;

pacote.configurar({

    // token de atendente (GET /atendimento/token)
    pedeToken: async () => {
        const { data } = await axios.get('/atendimento/token');
        if(!data || !data.status || !data.token){
            throw new Error((data && data.mensagem) || 'Não foi possível entrar no chat.');
        }
        return { token: data.token, validade: data.validade };
    },

    // empresa da conversa (GET /atendimento/empresa, sem valores)
    empresa: async codigo => (await axios.get('/atendimento/empresa', { params: { codigo } })).data,

    // dica da IA (POST /atendimento/dica)
    dica: async (conversaId, atualizar) => (await axios.post('/atendimento/dica', { conversaId, atualizar }, { timeout: 120000 })).data,

    // cadastro da empresa, aberto em outra janela pelo nome da empresa no painel do cliente
    linkEmpresa: id => `/painel/empresas/editar/${id}`
});

export default pacote;
